// PageIntegration Component

import React from 'react'
import async from 'async'
import _ from 'lodash'

import app from '../../../app.jsx'
import Util from '../../../lib/util.jsx'
import IntegrationForm from '../../../common/setting/integration_form/integration_form.jsx'
import BaseSettings from '../../page/base_setting/base_setting.jsx'

class PageIntegration extends BaseSettings {
  constructor (props) {
    super(props, 'setting-integration', 'setting-user', 'setting-integration')

    this.state = {
      isLoading: true,
      dataDate: null
    }

    this.data = {
      integration: {},
      quickbook: null
    }

    this._references = {
      pageHeader: React.createRef()
    }

    this._bUnMounted = false
  }

  componentDidMount () {
    this._getData()
  }

  componentWillUnmount () {
    this._bUnMounted = true
  }

  renderContent () {
    const quickbook = this.data.quickbook

    const showQuickbook = app.teamCountry === 'US'
    const showXero = app.teamCountry === 'UK'

    return (
      <IntegrationForm
        integration={this.data.integration}
        showQuickbook={showQuickbook}
        showXero={showXero}
        onSubmit={this._onSubmit.bind(this)}
        onError={this._onError.bind(this)}
        quickbookConnectUrl={`/quickbook/connect/${app.getTeamId()}`}
        onDisconnectQuickbook={this._onDisconnectQuickbook.bind(this)}
        showQuickbookConnected={quickbook && quickbook.isConnected}
        quickbookApplicationName={quickbook ? quickbook.companyName : ''}
      />
    )
  }

  getContentClassname () {
    return 'alt'
  }

  /* Event Handlers */
  _onChangePage (pageIdent) {
    app.changePage(pageIdent)
  }

  _onSubmit (integration) {
    this._saveIntegration(integration, err => {
      if (err) {
        this._onError(null)
      } else {
        this._reloadData()
        if (this._references.pageHeader.current) {
          this._references.pageHeader.current.showSuccess(
            'setting.integration.msgSuccessTitle',
            'setting.integration.msgSuccessContent'
          )
        }
      }
    })
  }

  _onError (field) {
    if (this._references.pageHeader.current) {
      this._references.pageHeader.current.showError(
        'setting.integration.msgErrorTitle',
        field || 'setting.integration.msgErrorInfo'
      )
    }
  }

  _reloadData () {
    this._getData()
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this._getDataIntegration(done)
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  async _getDataIntegration (callback) {
    app.debug('PageIntegration: _getDataIntegration [start]')

    try {
      const teamId = app.getTeamId()
      const team = await app.service('/api/team').get(teamId, {})
      this.data.integration = team.integration
      this.data.quickbook = team.quickbook
      app.setTeam(team.id)
      callback(null)
    } catch (err) {
      app.debug('PageIntegration: _getDataIntegration err', err)
      callback(err)
    }
  }

  _onDataReceived (err) {
    if (this._bUnMounted) return

    if (err) {
      app.debug('PageIntegration: _onDataReceived Error', err)
    } else {
      app.debug('PageIntegration: _onDataReceived [done]')
    }
    this.setState({ isLoading: !!err, dataDate: new Date() })
  }

  _onDisconnectQuickbook () {
    app.debug('PageIntegration: _onDisconnectQuickbook [start]')

    const teamId = app.getTeamId()
    app
      .service('/api/quickbook/revoke')
      .create({ teamId: teamId })
      .then(_result => {
        this._reloadData()
      })
      .catch(err => {
        app.debug('PageIntegration: _onDisconnectQuickbook err', err)
      })
  }

  _saveIntegration (integration, callback) {
    app.debug('PageIntegration: _saveIntegration [start]')

    const integrationData = Util.removeObjectKey(_.cloneDeep(integration), 'id')
    const teamId = app.getTeamId()
    app
      .service('/api/team')
      .patch(teamId, { integration: integrationData })
      .then(integrationRes => {
        app.debug('PageIntegration: _saveIntegration [done]')
        if (integrationRes) {
          this.data.integration = integrationRes
          callback(null)
        } else {
          callback({}) // eslint-disable-line standard/no-callback-literal
        }
      })
      .catch(integrationErr => {
        app.debug('PageIntegration: _saveIntegration Error', integrationErr)
        callback(integrationErr)
      })
  }
}

export default PageIntegration
